$(function () {
    $('.product-panel .jcarousel, .fitment-panel .jcarousel')
        .on('jcarousel:scroll', function(event, carousel, target, animate) {
            if (typeof target === 'string') {
                var newTarget = target.replace(/\d+/, '') + $(this).jcarousel('fullyvisible').length;

                if (newTarget !== target) {
                    $(this).jcarousel('scroll', newTarget);
                }
            }
        })
        .jcarousel();

    $('.product-panel .jcarousel-control-prev, .product-panel .jcarousel-control-next, .fitment-panel .jcarousel-control-prev, .fitment-panel .jcarousel-control-next')
        .on('jcarouselcontrol:active', function() {
            $(this).removeClass('inactive');
        })
        .on('jcarouselcontrol:inactive', function() {
            $(this).addClass('inactive');
        });

    $('.product-panel .jcarousel-control-prev, .fitment-panel .jcarousel-control-prev').jcarouselControl({
        target: '-=1'
    });

    $('.product-panel .jcarousel-control-next, .fitment-panel .jcarousel-control-next').jcarouselControl({
        target: '+=1'
    });
});